import axios, { AxiosError, AxiosResponse } from 'axios';
import { User, isUser } from 'Models';
import { Pagination } from 'Requests/Pagination';
import { Collection } from 'Requests/Collection';
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { ErrorResponse } from 'ValueObjects';
import Qs from 'qs';
import { Filterable } from 'Requests/Filterable';
import { QueryInvalidator } from 'Requests/QueryInvalidator';

export type UsersListRequestProps = Pagination & Filterable;
type Response = AxiosResponse<Collection<User>>;

export const UsersListRequest = async ({
  ...params
}: UsersListRequestProps): Promise<Response> =>
  axios.get(`api/users`, {
    params: { ...params },
    paramsSerializer: {
      encode: (param) => Qs.parse(param),
      serialize: (param) => Qs.stringify(param, { arrayFormat: 'brackets' }),
    },
  });

export const useUsersListRequest = (
  request: UsersListRequestProps,
  options: UseQueryOptions<Response, AxiosError<ErrorResponse>, Response> = {}
): UseQueryResult<Response, AxiosError<ErrorResponse>> =>
  useQuery<Response, AxiosError<ErrorResponse>, Response>({
    ...options,
    queryFn: async () => UsersListRequest(request),
    queryKey: ['users', 'list', ...Object.values(request)],
  });

export const UsersListRequestInvalidator: QueryInvalidator = (
  data,
  queryClient
) => {
  if (isUser(data)) {
    queryClient.invalidateQueries(['users', 'list']);
  }
};
